import { Card, CbhIcon, Text, Title } from "@clipboard-health/ui-components";
import { Box, CardActionArea, CardContent, Stack, useTheme } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useHistory, useLocation } from "react-router-dom";

import {
  SHIFT_DISCOVERY_LIST_PATH,
  SHIFT_DISCOVERY_MAP_PATH,
  SHIFT_DISCOVERY_RECOMMENDED_PATH,
} from "../paths";
import { useIsShiftRecommendationsEnabled } from "./hooks/useIsShiftRecommendationsEnabled";

export function ForYouButton() {
  const isForYouEnabled = useIsShiftRecommendationsEnabled();
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const disabled = false; // TODO: add logic to check if there are shifts to show

  if (!isForYouEnabled) {
    return null;
  }

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.SHIFT_DETAILS_OPENED, {
      context: "suggested_shifts_story_button",
    });

    const baseNavigationPath = location.pathname.includes(`/${SHIFT_DISCOVERY_MAP_PATH}`)
      ? `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_MAP_PATH}`
      : `${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`;

    history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_RECOMMENDED_PATH}`);
  };

  const getMessage = () => {
    if (disabled) {
      return "Come back later for a personalized list of shifts made just for you";
    }

    return "Check out this personalized list of shifts made just for you";
  };

  return (
    <Box sx={{ px: 5, pb: 2 }}>
      <Card
        sx={{
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
          background: `
            linear-gradient(${theme.palette.background.paper} 0 0) padding-box,
        ${
          disabled
            ? // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
              "linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%) border-box"
            : // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
              "linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 30%, #45b7d1 60%, #96ceb4 100%) border-box"
        }`,
          padding: "2px",
          border: "2px solid transparent",
          borderRadius: theme.borderRadius?.medium,
          filter: disabled ? "grayscale(100%)" : "none",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <CardActionArea
          disabled={disabled}
          data-testid="suggested-shifts-button"
          onClick={disabled ? undefined : handleClick}
        >
          <CardContent>
            <Stack direction="row" alignItems="center" spacing={2}>
              <CbhIcon
                type="new"
                size="large"
                sx={{
                  color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
                  filter: disabled ? "grayscale(100%)" : "none",
                }}
              />
              <Stack direction="column" alignItems="flex-start" sx={{ flex: 1 }}>
                <Title
                  semibold
                  variant="h6"
                  component="h3"
                  sx={{
                    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
                    mb: 1,
                  }}
                >
                  For You!
                </Title>
                <Text
                  variant="body2"
                  sx={{
                    color: disabled ? theme.palette.text.disabled : theme.palette.text.secondary,
                    textAlign: "left",
                  }}
                >
                  {getMessage()}
                </Text>
              </Stack>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
}
